export default "__VITE_ASSET__BsXERiSG__"